import React from 'react';
import { useGlobalDialogContext } from 'App/components/Layouts/Dashboard/dialog/GlobalDialog';
import { ConfirmEditDocumentTypeDialog } from './index';
import { DocumentTypeEnum } from '../../../../common/document/enums/document-type.enum';
import requestService from '../../../../store/request/service';

export const ConfirmEditDocumentTypeGlobalDialog = ({
  documentId,
  fromDocument,
  toDocument,
}: {
  documentId: string;
  fromDocument: {
    name: string;
    documentType: DocumentTypeEnum;
  };
  toDocument: {
    name: string;
    documentType: DocumentTypeEnum;
  };
}) => {
  const { hideDialog } = useGlobalDialogContext();

  const [changeDocumentType, { isLoading, isSuccess }] =
    requestService.endpoints.changeDocumentType.useMutation();

  const handleDialogToggle = () => {
    hideDialog();
  };

  const handleChangeDocumentType = () => {
    changeDocumentType({ documentId, documentType: toDocument.documentType });
  };

  return (
    <ConfirmEditDocumentTypeDialog
      open={true}
      setOpen={() => {
        handleDialogToggle();
      }}
      isLoading={isLoading || isSuccess}
      isSuccess={isSuccess}
      fromDocument={fromDocument}
      toDocument={toDocument}
      onConfirm={handleChangeDocumentType}
    />
  );
};
